import Audit from './index'
import Withdrawal from './Withdrawal'
import KYC from './KYC'
import DepositeRecords from './DepositeRecords'
import OfficialAvatarNickname from './OfficialAvatarNickname'
import UserRiskPanel from './UserRiskPanel'
import AuthLimit from './AuthLimit'
export default {
  path: '/home/audit',
  component: Audit,
  children: [
    { path: '/home/audit/withdrawal', component: Withdrawal },
    { path: '/home/audit/kyc', component: KYC },
    { path: '/home/audit/deposite/records', component: DepositeRecords },
    { path: '/home/audit/official/avatar-nickname', component: OfficialAvatarNickname },
    { path: '/home/audit/user-risk-panel', component: UserRiskPanel },
    { path: '/home/audit/authLimit', component: AuthLimit }
  ],
}
